import * as React from "react"
import * as ReactDOM from "react-dom"
import * as Immutable from "immutable"
import * as ViewUtils from "../generated_views/view_utils"
import * as LazyImage from "./lazy_image"
import * as Draft from 'draft-js';
import * as Moment from 'moment'
import { simple_application, rich_text } from "monadic_react"
import * as BlobImage from "./blob_image";
import DatePicker from 'react-datepicker';

function format_int(num:number, length:number) : string {
    return (num / Math.pow(10, length)).toFixed(length).substr(2);
}

export function Input(
  can_edit:boolean,
  mode:ViewUtils.EntityMode,
  get_item:()=>string,
  set_item:(v:string)=>void,
  type:"text"|"tel"|"url"|"email",
  name?: string,
  className?: string,
  validation?:(_:string)=>"ok"|{ error:string }) : JSX.Element {
  return mode == "view" ?
      <div>{get_item()}</div>
    :
      <input
        disabled={!can_edit}
        type={type}
        id={name}
        name={name}
        value={get_item()}
        className={className}
        onChange={(e) => {
          let new_value = (e.target as HTMLInputElement).value
          if (!validation || validation(new_value))
            set_item(new_value)
        } }/>
}

export function String(
  can_edit:boolean,
  mode:ViewUtils.EntityMode,
  get_item:()=>string,
  set_item:(v:string)=>void,
  name?: string,
  className?: string,
  validation?:(_:string)=>"ok"|{ error:string }) : JSX.Element {
  return Input(can_edit, mode, get_item, set_item, "text", name, className, validation)
}

export function Tel(
  can_edit:boolean,
  mode:ViewUtils.EntityMode,
  get_item:()=>string,
  set_item:(v:string)=>void,
  name?: string,
  className?: string,
  validation?:(_:string)=>"ok"|{ error:string }) : JSX.Element {
  let item = get_item()
  return mode == "view" ?
      <a href={`tel:${item}`}>{item}</a>
    :
      Input(can_edit, mode, get_item, set_item, "tel", name, className, validation)
}

export function Email(
  can_edit:boolean,
  mode:ViewUtils.EntityMode,
  get_item:()=>string,
  set_item:(v:string)=>void,
  name?: string,
  className?: string,
  validation?:(_:string)=>"ok"|{ error:string }) : JSX.Element {
  let item = get_item()
  return mode == "view" ?
      <a href={`mailto:${item}`}>{item}</a>
    :
      Input(can_edit, mode, get_item, set_item, "email", name, className, validation)
}

export function Url(
  can_edit:boolean,
  mode:ViewUtils.EntityMode,
  get_item:()=>string,
  set_item:(v:string)=>void,
  name?: string,
  className?: string,
  validation?:(_:string)=>"ok"|{ error:string }) : JSX.Element {
  let item = get_item()
  return mode == "view" ?
      <a href={`${item}`}>{item}</a>
    :
       Input(can_edit, mode, get_item, set_item, "url", name, className, validation)
}

export function Title(
  can_edit:boolean,
  mode:ViewUtils.EntityMode,
  get_item:()=>string,
  set_item:(v:string)=>void,
  name?: string,
  className?: string,
  validation?:(_:string)=>"ok"|{ error:string }) : JSX.Element {
  return mode == "view" ?
      <div className="model-preview">{get_item()}</div>
    :
      <input disabled={!can_edit} className={className} type="text" id={name} name={name}
        value={get_item()}
        onChange={(e) => {
          let new_value = (e.target as HTMLInputElement).value
          if (!validation || validation(new_value))
            set_item(new_value)
        } }/>
}

export function Text(
  can_edit:boolean,
  mode:ViewUtils.EntityMode,
  get_item:()=>string,
  set_item:(v:string)=>void,
  name?: string,
  className?: string,
  rows?: number,
  placeholder?: string,
  validation?:(_:string)=>"ok"|{ error:string }) : JSX.Element {
  return <textarea disabled={!can_edit || mode == "view"}
        value={get_item()}
        id={name}
        name={name}
        className={className}
        rows={rows}
        placeholder={placeholder}
        onChange={(e) => {
          let new_value = (e.target as HTMLTextAreaElement).value
          if (!validation || validation(new_value))
            set_item(new_value)
        } }/>
}

export function Number(
  can_edit:boolean,
  mode:ViewUtils.EntityMode,
  get_item:()=>number,
  set_item:(v:number)=>void,
  className?: string,
  validation?:(_:number)=>"ok"|{ error:string }) : JSX.Element {
  return mode == "view" ?
      <div>{(get_item() == NaN || get_item() == undefined ? '' : get_item())}</div>
    :
      <input
        disabled={!can_edit}
        type="number"
        className={className}
        value={`${get_item()}`}
        onChange={(e) => {
          let new_value = (e.target as HTMLInputElement).valueAsNumber
          if (isNaN(new_value)) new_value = 0
          if (!validation || validation(new_value))
            set_item(new_value)
        } }/>
}


export function NullableNumber(
  can_edit: boolean,
  mode: ViewUtils.EntityMode,
  get_item: () => number,
  set_item: (v: number | null) => void
): JSX.Element {
  return mode == 'view' ? (
    <div>{get_item() == NaN || get_item() == undefined ? '' : get_item()}</div>
  ) : (
    <input
      disabled={!can_edit}
      type="number"
      value={`${get_item()}`}
      onChange={e => {
        let new_value = (e.target as HTMLInputElement).valueAsNumber
        set_item(!isNaN(new_value) ? new_value : null)
      }}
    />
  )
}

export function Boolean(
  can_edit:boolean,
  mode:ViewUtils.EntityMode,
  get_item:()=>boolean,
  set_item:(v:boolean)=>void) : JSX.Element {
  return <input
    disabled={!can_edit || mode == "view"}
    type="checkbox"
    checked={get_item()}
    onChange={(e) => {
      set_item((e.target as HTMLInputElement).checked)
    } }
  />
}

export function DateTime(
  can_edit:boolean,
  mode:ViewUtils.EntityMode,
  get_item:()=>Moment.Moment,
  set_item:(v:Moment.Moment)=>void) : JSX.Element {
  let item = get_item()
  return mode == "view" ?
    <div>{ `${format_int(item.date(), 2)}/${format_int(item.month()+1, 2)}/${format_int(item.year(), 4)}  ${format_int(item.hours(), 2)}:${format_int(item.minutes(), 2)}` }</div>
  : 
    <DatePicker 
      adjustDateOnChange
      disabled={!can_edit}
      selected={item.toDate()}
      onChange={(value) => {
        set_item(Moment.utc(value))
      }}
      showTimeSelect
      timeFormat="HH:mm"
      timeIntervals={15}
      locale="nl"
      dateFormat="MMMM d, yyyy HH:mm"
      timeCaption="time"
    />
}

export function DateOnly(
  can_edit:boolean,
  mode:ViewUtils.EntityMode,
  get_item:()=>Moment.Moment,
  set_item:(v:Moment.Moment)=>void,
  className?: string) : JSX.Element {
  let item = get_item()
  let default_value = `${format_int(item.year(), 4)}-${format_int(item.month()+1, 2)}-${format_int(item.date(), 2)}`
  return mode == "view" ?
    <div>{ `${format_int(item.date(), 2)}/${format_int(item.month()+1, 2)}/${format_int(item.year(), 4)}` }</div>
  : 
    <DatePicker
      className={className}
      adjustDateOnChange
      disabled={!can_edit}
      selected={item.toDate()}
      onChange={(value) => {
        set_item(Moment.utc(value).startOf('d').add(12, 'h'))
      }}
      locale="nl"
      dateFormat="MMMM d, yyyy"
    />
}

export function Time(
  can_edit:boolean,
  mode:ViewUtils.EntityMode,
  get_item:()=>Moment.Moment,
  set_item:(v:Moment.Moment)=>void) : JSX.Element {
  let item = get_item()
  let default_value = `${format_int(item.hours(), 2)}:${format_int(item.minutes(), 2)}`
  return mode == "view" ?
    <div>{ default_value }</div>
  :
    <DatePicker
      disabled={!can_edit}
      selected={get_item().toDate()}
      onChange={(value) => {
        set_item(Moment.utc(value))
      }}
      showTimeSelect
      showTimeSelectOnly
      timeIntervals={15}
      dateFormat="HH:mm"
      timeCaption="Time"
    />
}

export type UnionCase = { value:string, label:string }

export function Union(
  can_edit:boolean,
  mode:ViewUtils.EntityMode,
  options:Immutable.List<UnionCase>,
  get_item:()=>string|null,
  set_item:(v:string)=>void,
  name?: string,
  default_value?: string,
) : JSX.Element {
  let item = get_item()
  let current = options.find(o => o.value == item)
  return mode == "view" ? <div>{current ? current.label : ""}</div> :
    <div className="form__select">
      <select
        value={item}
        id={name}
        name={name}
        onChange={(s:React.FormEvent<HTMLSelectElement>) => set_item(s.currentTarget.value)}
      >
        {default_value && <option key={default_value} value='' disabled>{default_value}</option>}
        {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </div>
}

export function Image(
    can_edit:boolean,
    mode:ViewUtils.EntityMode,
    get_item:()=>Promise<string>,
    set_item:(src:string)=>Promise<void>) {
  return <LazyImage.LazyImage
      can_edit={can_edit && mode == "edit"}
      download={() => get_item()}
      upload={(new_src:string) => set_item(new_src)} />
}

export function Blob(
    can_edit:boolean,
    mode:ViewUtils.EntityMode,
    src:string,
    delete_item:()=>Promise<void>,
    set_item:(src:File)=>Promise<void>) {
  return <BlobImage.BlobImage
      can_edit={can_edit && mode == "edit"}
      src={src}
      delete={() => delete_item()}
      upload={(new_src:File) => set_item(new_src)} />
}

export function RichText(
  can_edit:boolean,
  mode:ViewUtils.EntityMode,
  get_item:()=>string|null,
  set_item:(src:string)=>void) {
    let item = get_item()
    return simple_application<string>(rich_text(can_edit ? mode : "view")(item), (out) => can_edit? set_item(out) : null)
}

export function File(
    can_edit:boolean,
    mode:ViewUtils.EntityMode,
    url:string,
    label:string,
    upload:(f:File) => Promise<void>) {
  return <div>
    <span>Filename:
        <a href={url} >{label}</a></span>
      {mode == "view" ? null :
          <input disabled={!can_edit}
              type="file"
              onChange={(e:any) => {
                  let files:FileList = (e.target as any).files
                  upload(files[0])
                }
              } />
      }
    </div>
}

export function AzureImage(
    can_edit: boolean,
    mode: ViewUtils.EntityMode,
    url: string,
    label: string,
    upload: (f: File) => Promise<void>) {
    return <div>
        <span>Azure Url:
        <a href={url} >{label}</a></span>
        {mode == "view" ? null :
            <input disabled={!can_edit}
                type="file"
                onChange={(e: any) => {
                    let files: FileList = (e.target as any).files
                    upload(files[0])
                }
                } />
        }
    </div>
}
